// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".floating-comment[data-v-387b473b] {\n  opacity: var(--opacity);\n  position: absolute;\n  transform: scale(var(--scale));\n}", ""]);
// Exports
module.exports = exports;
